import {Button} from '../Button';
import {DecorativeCircles} from '../DecorativeCircles';
import {Icon} from '../Icon';
import {Typography} from '../Typography';

import type {ReactNode, FC} from 'react';

export interface ListEmptySearchProps {
  title: string;
  subtitle: ReactNode;
  clearLabel: string;
  onClear: () => void;
}

export const ListEmptySearch: FC<ListEmptySearchProps> = ({
  title,
  subtitle,
  clearLabel,
  onClear
}) => {
  return (
    <div data-slot="list-empty-search" className="flex min-h-96 items-center justify-center">
      <div className="flex max-w-lg flex-col items-center gap-6 text-center">
        <DecorativeCircles>
          <div className="flex size-12 items-center justify-center rounded-lg border border-border bg-background-surface shadow-xs">
            <Icon name="search" className="size-6 text-fg-secondary" />
          </div>
        </DecorativeCircles>
        <div className="flex flex-col items-center gap-1">
          <Typography as="h3" size="md" weight="semibold">
            {title}
          </Typography>
          <Typography size="sm" color="tertiary" className="max-w-88">
            {subtitle}
          </Typography>
        </div>
        <Button variant="secondary" size="sm" onClick={onClear}>
          {clearLabel}
        </Button>
      </div>
    </div>
  );
};
